import { Version } from '@angular/core';

export const VERSION = new Version('9.0.0');
